import { Alert } from "@material-ui/lab";
import React, { useEffect, useState } from "react";

const PayoutFailTimerAlert = ({ payout, t }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const remaining = 15 * 60 - (Date.now() / 1000 - payout.updatedAt);

    setSeconds(Math.floor(remaining));
  }, [payout]);

  useEffect(() => {
    if (seconds <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds > 0]);

  if (seconds <= 0) {
    return null;
  }

  return (
    <Alert severity="warning" className="payout-details-head__alert">
      {t("failTransaction.timer")} {String(Math.floor(seconds / 60)).padStart(2, "0")}:{String(seconds % 60).padStart(2, "0")}
    </Alert>
  );
};

export default PayoutFailTimerAlert;